import { FormattedMessage as FM } from "react-intl";

import { cn } from "tools/ui";

function fmtKindTime(value) {
  return value ? String(value).slice(0, 5) : "--:--";
}

function Item({ label, value }) {
  return (
    <div className="flex flex-col">
      <span className="text-[11px] uppercase tracking-wide text-neutral-500">
        <FM id={label} />
      </span>
      <span className="text-sm font-semibold text-neutral-800">{value}</span>
    </div>
  );
}

function ShiftHoursInfo({ record, style }) {
  if (!record) return null;

  const shift = record["shift."] ?? record.shift;
  const kind = shift?.["shift_kind."] ?? shift?.shift_kind ?? {};

  return (
    <div
      className={cn(
        "rounded-lg border border-sky-200 bg-sky-50 p-3 flex flex-col gap-3 mt-2",
        style,
      )}
    >
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Item label="staff.access.kind_start" value={fmtKindTime(kind.start)} />
        <Item
          label="staff.access.kind_start_rest"
          value={fmtKindTime(kind.start_rest)}
        />
        <Item
          label="staff.access.kind_end_rest"
          value={fmtKindTime(kind.end_rest)}
        />
        <Item label="staff.access.kind_end" value={fmtKindTime(kind.end)} />
      </div>
    </div>
  );
}

export default ShiftHoursInfo;
